import React, { useEffect, useState } from "react";
import AuthHeader from "src/components/@auth/auth-layout/auth-header";
import { createFoldername } from "./action";
import { useNavigate, useSearchParams } from "react-router-dom";
import FileManager from ".";
import PrimaryButton from "src/components/reusable/button/primary-button";

const CreateFolder = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [folderName, setFolderName] = useState("");
  const [folderNameError, setFolderNameError] = useState("");

  const [submittingAction, setSubmittingAction] = useState(false);

  const updateQuery = (folderName: string) => {
    setSearchParams({ folder: folderName });
  };

  const handleSubmitCreateFolder = () => {
    if (submittingAction) {
      return;
    }
    let hasError = false;
    if (!folderName.trim()) {
      setFolderNameError("Folder name is required.");
      hasError = true;
    } else if (folderName.length > 50) {
      setFolderNameError("Folder name cannot be more than 50 characters.");
      hasError = true;
    } else {
      setFolderNameError("");
    }

    if (hasError) return;

    setSubmittingAction(true);

    // Now use folderName and selectedFiles
    createFoldername(folderName, ({ success, errorType }) => {
      setSubmittingAction(false);
      if (errorType === "create") {
        setFolderNameError("Folder with the same name already exist");
        return;
      }
      if (success) {
        updateQuery(folderName);
      }
    });
  };

  useEffect(() => {
    const accessGranted = localStorage.getItem("dropboxAccess");
    if (accessGranted !== "granted") {
      navigate("/dropbox-login", { replace: true });
    }
  }, []);

  return (
    <>
      <AuthHeader />
      {searchParams.get("folder") ? (
        <FileManager />
      ) : (
        <div className="p-6 max-w-4xl mx-auto font-sans min-h-[calc(100vh-88px)]">
          {/* Action Buttons */}
          <div className="mb-3">
            <p className="text-lg font-bold mb-2">{"Folder Name"}</p>
            <input
              type="text"
              placeholder={`Folder name`}
              value={folderName}
              onChange={(e) => {
                setFolderName(e.target.value);
                setFolderNameError("");
              }}
              className="mt-1 block w-full px-2 py-[13px] border-gray-300 border-[1px] focus:outline-none focus:ring-2"
            />
            {folderNameError && <div className="text-xs text-danger-500">{folderNameError}</div>}
          </div>
          <PrimaryButton
            onClick={handleSubmitCreateFolder}
            text="Create Folder"
            loading={submittingAction}
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={16}
                height={16}
                viewBox="0 0 49 48"
                fill="none"
              >
                <path
                  fill="white"
                  fillRule="evenodd"
                  d="M22.748.76A2.389 2.389 0 0 1 24.5 0c.615 0 1.229.234 1.7.704l11.996 11.997a2.4 2.4 0 1 1-3.393 3.395l-7.904-7.904v23.003a2.4 2.4 0 1 1-4.8 0V8.197l-7.9 7.9a2.4 2.4 0 0 1-3.392-3.396L22.747.761ZM2.903 28.803c1.326 0 2.401 1.075 2.401 2.4V40.8A2.397 2.397 0 0 0 7.703 43.2h33.593a2.4 2.4 0 0 0 2.4-2.398v-9.599a2.4 2.4 0 1 1 4.8 0V40.8a7.2 7.2 0 0 1-7.2 7.2H7.703c-1.91 0-3.74-.758-5.09-2.108A7.196 7.196 0 0 1 .503 40.8v-9.598c0-1.325 1.075-2.4 2.4-2.4Z"
                  clipRule="evenodd"
                />
              </svg>
            }
          />
        </div>
      )}
    </>
  );
};

export default CreateFolder;
